import { useFormik } from "formik";
import { Avatar } from "primereact/avatar";
import { Sidebar } from "primereact/sidebar";
import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import fotoNeutro from "../../assets/img/avatar-neutro.png";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import DialogZegel from "../../components/Dialog/DialogZegel";
import InputPastZegel from "../../components/Inputs/InputPassZegel";
import * as constantes from "../../constants/constantes";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { UpdatePassword } from "../../services/UsuarioService";
import BienvenidaCursoPrograma from "../Curso/BienvenidaCursoPrograma";
import BienvenidaCurso from "../Curso/BienvenidaCurso";
import BienvenidaPrograma from "../Curso/BienvenidaPrograma";
import CursoInterno from "../Curso/CursoInterno";
import ProgresoCurso from "../Curso/ProgresoCurso";
import ShareCertificate from "../Curso/ShareCertificate";
import ProgresoPrograma from "../Curso/ProgresoPrograma";
import Dashboard from "../Dashboard/Dashboard";
import EvaluacionExamen from "../Evaluacion/EvaluacionExamen";
import EvaluacionIntro from "../Evaluacion/EvaluacionIntro";
import ResultadosExamen from "../Evaluacion/ResultadosExamen";
import "./styles/Home.scss";
import zegelVirtualPositivo from "../../assets/img/zegelVirtualPositivo.png";

//import * as Iconsax from "iconsax-react";
const Home = () => {
  const navigate = useNavigate();
  const {
    perfil,
    isLogged,
    logout,
    setActivosChecked,
    setFinalizadoChecked,
    setExplorarChecked,
    setIndexActiveCursos,
    setIndexTabPrincipal,
    setIndexTabSecundario
  } = useAlumno();
  const [showChangePass, setShowChangePass] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [contenidoAlert, setContenidoAlert] = useState("");
  useEffect(() => {
    //if (!isLogged) window.location = "#/";
    if (!isLogged) navigate("/Login");
  }, [isLogged]);
  const [visible, setVisible] = useState(false);
  //const Dashboard = lazy(() => import("../Dashboard/Dashboard"));
  const customIcons = (
    <div
      style={{ width: "100%", height: "40px" }}
      className="flex align-items-center"
    >
      <button
        className="p-sidebar-icon p-link mr-2"
        onClick={() => {
          if (showChangePass) {
            setShowChangePass(false);
          } else {
            setVisible(false);
          }
        }}
      >
        <span className="pi pi-arrow-left" />
      </button>
    </div>
  );
  const toggleSidebar = () => {
    setVisible(!visible);
  };
  const cerrarSesion = (e) => {
    e.preventDefault();
    logout();
  };

  const schema = Yup.object().shape({
    passwordOld: Yup.string().required(
      "Contraseña actual es un campo obligatorio"
    ),
    // password: Yup.string().required("Contraseña es un campo obligatorio").min(8, "La contraseña debe tener al menos 8 caracteres"),
    password: Yup.string()
      .required("Contraseña es un campo obligatorio")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Tu nueva contraseña debe poseer una extensión de al menos 8 caracteres y contener una mayúscula y un número."
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      passwordRepetido: "",
      passwordOld: "",
    },

    validationSchema: schema,
    onSubmit: (values) => {
      let id = perfil.idUsuario; //
      let password = values.password;
      let passwordRepetido = values.passwordRepetido;
      let passwordOld = values.passwordOld;
      let guid = "11776c46-4df2-487a-97bc-e9c756c95bd7";

      if (passwordRepetido != password) {
        setContenidoAlert("Contraseñas no coinciden.");
        setShowAlert(true);
        formik.setSubmitting(false);
        return;
      }

      let jsonpass = JSON.stringify(
        {
          id,
          guid,
          password,
          passwordOld,
        },
        null,
        2
      );
      let jwt = window.localStorage.getItem("jwt");
      UpdatePassword({ jwt, jsonpass })
        .then((data) => {
          formik.setSubmitting(false);
          setContenidoAlert("Se actualizó contraseña correctamente.");
          setShowAlert(true);
          setTimeout(() => {
            setShowChangePass(false);
            setVisible(false);
            formik.resetForm();
          }, 3000);
        })
        .catch((errors) => {
          setShowChangePass(false);
          setVisible(false);
          setContenidoAlert(errors.message);
          setShowAlert(true);
          formik.setSubmitting(false);
        });
    },
  });
  return (
    <div className="zal-home">
      <div className="zal-home-topbar">
        <ul className="container">
          <li className="topbar-option logoTopbar">
            <Link to={"/" + PrivateRoutes.HOME + "/Dashboard"}>
              <div className="c-icon logoTopbar">
                <img
                  src={zegelVirtualPositivo}
                  height={40}
                  style={{ height: 40 }}
                />
              </div>
            </Link>
          </li>
          <li className="topbar-option help>">
            <Link
              style={{ textDecoration: "none" }}
              to={constantes.URL_AYUDA}
              target="_blank"
            >
              <div className="c-icon">
                <span className="text-help">¿Necesitas Ayuda?</span>
              </div>
            </Link>
          </li>
          <li className="topbar-option">
            <Link>
              <div className="c-icon menuTopBar" onClick={toggleSidebar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                >
                  <path
                    id="menu001_-_E002"
                    data-name="menu001 - E002"
                    d="M8-40.5H-16v1.571H8ZM8-30.286H-16v1.571H8ZM8-20.071H-16V-18.5H8Z"
                    transform="translate(16 40.5)"
                    fill="#2b2b2b"
                  ></path>
                </svg>
              </div>
            </Link>
          </li>
        </ul>
      </div>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        icons={customIcons}
        position="right"
        className="sidebarHome"
        showCloseIcon={false}
      >
        {!showChangePass ? (
          <>
            <div className="sidebar-avatar flex align-items-center justify-content-center gap-5">
              <Avatar
                image={perfil && (perfil.avatar ? perfil.avatar : fotoNeutro)}
                style={{
                  width: 100,
                  height: 100,
                  minWidth: 100,
                  minHeight: 100,
                }}
                shape="circle"
                //onImageError={()=>alert("error imagen")}
                imageFallback={fotoNeutro}
              />
              <label className="text-xl font-bold">
                {perfil &&
                  perfil.nombres +
                  " " +
                  perfil.primerApellido +
                  " " +
                  perfil.segundoApellido}
              </label>
            </div>
            <div className="sidebar-acciones flex align-items-center justify-content-center">
              <div className="grid gap-4">
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {
                    setIndexActiveCursos(0);
                    setActivosChecked("curso-activo");
                    setFinalizadoChecked("");
                    setExplorarChecked("");
                    setVisible(false);
                    setIndexTabPrincipal(0)
                  }}
                >
                  Activos
                </Link>
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {

                    setIndexActiveCursos(1);
                    setActivosChecked("");
                    setFinalizadoChecked("curso-finalizado");
                    setExplorarChecked("");
                    setVisible(false);
                    setIndexTabPrincipal(1)
                  }}
                >
                  Finalizados
                </Link>
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {
                    setIndexActiveCursos(2);
                    setActivosChecked("");
                    setFinalizadoChecked("");
                    setExplorarChecked("curso-explorado");
                    setVisible(false);
                    setIndexTabPrincipal(2)
                  }}
                >
                  Explorar
                </Link>
              </div>
            </div>
            <div className="sidebar-footer">
              <div className="f-item footer-changePass flex align-items-center justify-content-between">
                <label
                  className="text-sm font-bold"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowChangePass(true)}
                >
                  Cambiar contraseña
                </label>
                <button
                  className="p-link mt-1"
                  onClick={() => setShowChangePass(true)}
                >
                  <span className="pi pi-cog" />
                </button>
              </div>
              <div className="f-item footer-logout flex align-items-center justify-content-between">
                <label
                  className="text-sm font-bold"
                  onClick={cerrarSesion}
                  style={{ cursor: "pointer" }}
                >
                  Cerrar sesión
                </label>
                <button className="p-link mt-1" onClick={cerrarSesion}>
                  <span className="pi pi-sign-out" />
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className=" justify-content-center">
            {/* <span style={{ cursor: "pointer" }} onClick={() => setShowChangePass(false)}>
              <Iconsax.ArrowCircleLeft size={30}></Iconsax.ArrowCircleLeft>
            </span> */}
            <div>
              <button
                className="p-link-button button-img "
                onClick={() => setShowChangePass(false)}
                style={{
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                <i
                  className="pi pi-arrow-left font-bold"
                  style={{ fontSize: "1rem" }}
                ></i>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="lf-credenciales formgrid grid justify-content-center ">
                <div
                  className="field col-12 md:col-12  mt-5"
                  style={{ textAlign: "center" }}
                >
                  <span
                    className="text-title-24"
                    style={{ textAlign: "center" }}
                  >
                    Cambiar contraseña
                  </span>
                </div>
                <div className="field col-12 md:col-12 ">
                  <span className="text-normal-12">
                    Tu nueva contraseña debe poseer una extensión de al menos 8
                    caracteres y contener una mayúscula y un número.
                  </span>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="passwordOld"
                      name="passwordOld"
                      value={formik.values.passwordOld}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="passwordOld"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Contraseña actual
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.passwordOld && formik.errors.passwordOld}
                  </small>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="password"
                      name="password"
                      value={formik.values.password}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="pass"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Nueva contraseña
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.password && formik.errors.password}
                  </small>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="passwordRepetido"
                      name="passwordRepetido"
                      value={formik.values.passwordRepetido}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="pass"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Repetir contraseña
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.passwordRepetido &&
                      formik.errors.passwordRepetido}
                  </small>
                </div>

                <div className="field col-12 md:col-12 mt-1">
                  <ButtonZegel
                    label="Actualizar contraseña"
                    color="primary"
                    type="submit"
                    loading={formik.isSubmitting}
                  ></ButtonZegel>
                </div>
              </div>
            </form>
          </div>
        )}
      </Sidebar>
      <div className="layout-main">
        <Routes>
          <Route path={"Dashboard"} element={<Dashboard />}></Route>
          <Route
            path={"ProgresoCurso/:idCurso"}
            element={<ProgresoCurso />}
          ></Route>
   
           <Route
            path={"ShareCertificate/Course/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
          <Route
            path={"ShareCertificate/Program/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
          <Route
            path={"ShareCertificate/InternalCourse/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
           <Route
            path={"BienvenidaCursoPrograma/:idCursoUsuario"}
            element={<BienvenidaCursoPrograma />}
          ></Route>
          <Route
            path={"BienvenidaCurso/:idCursoUsuario"}
            element={<BienvenidaCurso />}
          ></Route>
          <Route
            path={"BienvenidaPrograma/:idCursoUsuario"}
            element={<BienvenidaPrograma />}
          ></Route>
          <Route
            path={"CursoInterno/:idCursoUsuario"}
            element={<CursoInterno />}
          >
            <Route
              path={":idUnidad/:IDLeccion"}
              element={<CursoInterno />}
            ></Route>
            <Route
              path={":idUnidad/:IDLeccion/:idPersonaPrograma"}
              element={<CursoInterno />}
            ></Route>
          </Route>
          <Route
            path={"ProgresoPrograma/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ProgresoPrograma />}
          ></Route>
          <Route
            path={"Evaluacion/Introduccion/:IdPersonaCurso/:Intento/:idUnidad"}
            element={<EvaluacionIntro />}
          ></Route>
          <Route
            path={"Evaluacion/Examen/:IdPersonaCurso/:idEvaluacion/:idUnidad"}
            element={<EvaluacionExamen />}
          ></Route>
          <Route
            path={
              "Evaluacion/Resultado/:IdPersonaCurso/:idEvaluacion/:idUnidad"
            }
            element={<ResultadosExamen />}
          ></Route>
        </Routes>
      </div>
      <DialogZegel
        header=""
        visible={showAlert}
        width="30vw"
        onHide={() => setShowAlert(false)}
        footer={<></>}
        contenido={contenidoAlert}
      ></DialogZegel>
    </div>
  );
};

export default Home;
